import { useEffect, useMemo, useRef, useState } from 'react';
import { Breakpoints, SelectorType, TabDesign, Tabs, useBreakpoint } from '@nextgen-web-framework/all';
import { QuickFilterProps } from './types/propTypes';
import styles from './QuickFilter.module.scss';

const QuickFilter = ({ apliedQuickFilter, availableQuickFilters, loading, updateQuickFilter }: QuickFilterProps) => {
  const [selectedQuickFilter, setSelectedQuickFilter] = useState(0);
  const currentSelectedFilterTab = useRef<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const viewPortType = useBreakpoint() as Breakpoints;
  const { XS, SM, MD } = Breakpoints;
  const quickFilters = useMemo(() => {
    if (availableQuickFilters.length) {
      return [
        { title: 'All', id: '' },
        ...availableQuickFilters.map((name, index) => ({
          title: name,
          id: name,
          disabled: loading && selectedQuickFilter != index + 1,
        })),
      ];
    }
    return [];
  }, [loading, selectedQuickFilter]);

  useEffect(() => {
    const callback = () => {
      const top = viewPortType === MD ? 80 : 60;
      if (containerRef.current && containerRef.current?.getBoundingClientRect().top <= top) {
        containerRef.current.classList.add(styles['sticky']);
      } else {
        containerRef.current?.classList.remove(styles['sticky']);
      }
    };

    if ([XS, SM, MD].includes(viewPortType) && containerRef.current) {
      document.addEventListener('scroll', callback);
    }

    return () => document.removeEventListener('scroll', callback);
  }, [containerRef.current, viewPortType]);

  useEffect(() => {
    const index = availableQuickFilters.indexOf(apliedQuickFilter);
    const position = index + 1;
    setSelectedQuickFilter(position);
    currentSelectedFilterTab.current = position;
  }, [availableQuickFilters, apliedQuickFilter]);

  const handleQuickFiltersClick = (tab: number, id?: string) => {
    if (currentSelectedFilterTab.current != tab) {
      setSelectedQuickFilter(tab);
      currentSelectedFilterTab.current = tab;
      updateQuickFilter(String(id ?? ''));
    } else {
      setSelectedQuickFilter(0);
      currentSelectedFilterTab.current = 0;
      updateQuickFilter('');
    }
  };

  return (
    <div ref={containerRef} id="quick-filter" className={`${styles['content-search-filter']}`}>
      <Tabs
        tabList={quickFilters}
        selectedTab={selectedQuickFilter}
        design={TabDesign.PILL}
        selectorType={SelectorType.CIRCLE}
        onTabClick={handleQuickFiltersClick}
        className={styles['quick-filters']}
      />
    </div>
  );
};

export default QuickFilter;
